import { render, staticRenderFns } from "./sales_mobile_app.vue?vue&type=template&id=28665e0a&"
import script from "./sales_mobile_app.vue?vue&type=script&lang=js&"
export * from "./sales_mobile_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports